module.exports = __webpack_public_path__ + "static/media/companies.05a62f10.svg";